// Services
import AjaxService from './ajax.service';
import KendoFormatService from './kendo-format.service';

export default {
  async getGridData({ apiUrl, params }, columns) {
    const response = await AjaxService.getData(apiUrl, params);

    if (!response) return {};

    const { data, headers } = response;
    const kendoData = KendoFormatService.formatItemData(data, columns);

    return { kendoData, data, headers };
  },

  async getReportData({ apiUrl, params }) {
    return AjaxService.getData(apiUrl, params);
  },

  async getSampleById({ apiUrl, params }) {
    return AjaxService.getData(apiUrl, params);
  },

  async getGraphData({ apiUrl, params }) {
    return AjaxService.getData(apiUrl, params);
  }
};
